module.exports = __webpack_public_path__ + "static/media/jon.c2f3d9dd.jpeg";